// extracted by mini-css-extract-plugin
export default {"container":"Section2_container__+M-Ix","content":"Section2_content__eWN8k","titleContent":"Section2_titleContent__xvvt5","text":"Section2_text__GJI18","box":"Section2_box__D1TNc"};